import http_request from './http_request'
import config from 'config'

function createOeqLesson() {
	return http_request.post(`${config.api}quick_launch/oeq`)
		.send()
}

function createDrawItLesson() {
	return http_request.post(`${config.api}quick_launch/draw_it`)
		.send()
}

function createCollaborateLesson() {
	return http_request.post(`${config.api}quick_launch/collaborate`)
		.send()
}

export default {
	createOeqLesson,
	createDrawItLesson,
	createCollaborateLesson,
}
